import clsx from 'clsx';

export type StatusTone = 'idle' | 'active' | 'done' | 'error';

export interface StatusChipProps {
  label: string;
  tone?: StatusTone;
  className?: string;
}

const toneClasses: Record<StatusTone, string> = {
  idle: 'text-ink-subtle',
  active: 'text-blue-deep',
  done: 'text-ink',
  error: 'text-[#b33a3a]',
};

/**
 * Monospace telemetry-style chip. Consumer passes an already-formatted label
 * (uppercase, underscored between words). Renders as `> LABEL_HERE`.
 */
export function StatusChip({ label, tone = 'idle', className }: StatusChipProps) {
  return (
    <span
      className={clsx(
        'inline-flex items-center gap-1.5 font-mono text-[11px] uppercase tracking-[0.1em]',
        toneClasses[tone],
        className,
      )}
    >
      {tone === 'active' ? (
        <span
          aria-hidden="true"
          className="inline-block w-[5px] h-[5px] rounded-full bg-gradient-primary zg-pulse-dot"
        />
      ) : null}
      <span aria-hidden="true">&gt;</span>
      <span>{label}</span>
    </span>
  );
}
